import {
    IApontamentoHoras,
    IListarTipoCompromisso,
    IUsuariosComAcessoResponse,
} from "../../../../Interfaces/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasInterfaces";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export function ListarApontamentoDeHorasServices(idCaso: number) {
    return Service(
        Axios.get<Array<IApontamentoHoras>>(
            `/assistenciatecnica/atendimentos/listarapontamentodehoras?idCaso=${idCaso}`
        )
    );
}

export function AbrirAtendimentoVinculadoService(
    requestBody: IApontamentoHoras
) {
    return Service(
        Axios.post<IApontamentoHoras>(
            `/assistenciatecnica/atendimentos/inserirapontamentodehoras`,
            requestBody
        )
    );
}

export function ListarUsuariosAtivosComAcessoCasoServices(idTipoCaso: number) {
    return Service(
        Axios.get<Array<IUsuariosComAcessoResponse>>(
            `/assistenciatecnica/atendimentos/listarusuariosativoscomacessoaocaso?idTipoCaso=${idTipoCaso}`
        )
    );
}

export function ListarTipoCompromissoServices() {
    return Service(
        Axios.get<Array<IListarTipoCompromisso>>(
            `/home/agendamento/listatipocompromisso`
        )
    );
}
